import React from "react";
import { S, openConsult } from "../site.js";

const startConsultation = openConsult({ source: "home-final-cta" });

function HomeFinalCTA() {
  const openNextAI = (event) => {
    event.preventDefault();
    window.dispatchEvent(new CustomEvent("nx:consult:open", {
      detail: {
        focusComposer: true,
        source: "home-final-cta",
      },
    }));
  };

  return (
    <section className="section-pad home-final-cta" id="next-step" aria-labelledby="home-final-cta-title">
      <div className="container">
        <div className="home-final-cta-surface">
          <span className="home-final-cta-mark home-final-cta-mark--tl" aria-hidden="true" />
          <span className="home-final-cta-mark home-final-cta-mark--tr" aria-hidden="true" />
          <span className="home-final-cta-mark home-final-cta-mark--bl" aria-hidden="true" />
          <span className="home-final-cta-mark home-final-cta-mark--br" aria-hidden="true" />

          <div className="home-final-cta-copy">
            <div className="eyebrow">NEXT STEP</div>
            <h2 id="home-final-cta-title">Talk with our team about the next practical step.</h2>
            <p>
              Tell us what you are trying to improve. We will help you choose a clear starting point and the right conversation.
            </p>
            <div className="home-final-cta-actions">
              <a
                href={S.nextStep}
                className="btn btn-primary btn-arrow home-final-cta-button"
                onClick={startConsultation}
              >
                <span>Start a consultation</span>
              </a>
              <a
                href={S.ai}
                className="btn btn-secondary btn-arrow home-final-cta-button"
                onClick={openNextAI}
              >
                <span>Ask Next AI</span>
              </a>
            </div>
          </div>

          <div className="home-final-cta-visual" aria-hidden="true">
            <img src="/assets/section-12-final-cta/next-step-cobalt-ribbon-v1.png" alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}

export { HomeFinalCTA };
